import styled from 'styled-components';

export const AvatarPicker = styled.div`
  display: flex;
  min-width: 80px;
  min-height: 80px;
  justify-content: center;
  align-items: center;
`;
